import styles from "./EditLearner.module.css";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Modal from "../../components/Modal/Modal";
import dayjs from "dayjs";
import learnerService from "../../services/learner.service";
import ScreenHeader from "../../components/ScreenHeader/ScreenHeader";

const EditLearner = () => {
  const { id } = useParams();
  const [name, setName] = useState("");
  const [section, setSection] = useState("Castores");
  const [birthDate, setbirthDate] = useState();
  
  // Estados de modales simplificados
  const [modal, setModal] = useState({ type: null, isOpen: false });
  const [newLearnerId, setNewLearnerId] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
    const fetchLearner = async () => {
      const response = await learnerService.getLearner(id);
      _setLearner(response.data);
    };
    if (id !== "new") {
      fetchLearner();
    }
  }, [id]);

  const _setLearner = (learner) => {
    setName(learner.name);
    setSection(learner.section);
    setbirthDate(learner.birthDate);
  };

  const openModal = (type) => setModal({ type, isOpen: true });
  const closeModal = () => {
    const currentType = modal.type;
    setModal({ type: null, isOpen: false });
    
    // Acciones post-cierre
    if (currentType === "success" && newLearnerId) {
      navigate(`/editLearner/${newLearnerId}`);
      setNewLearnerId(null);
    } else if (currentType === "deleted") {
      navigate("/dashboard");
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (name === "" || section === "") {
      openModal("error");
      return;
    }

    const response =
      id !== "new"
        ? await learnerService.updateLearner(id, { name, section, birthDate })
        : await learnerService.newLearner({ name, section, birthDate });

    if (response.status === 200) {
      if (id === "new") {
        setNewLearnerId(response.data._id);
      }
      openModal("success");
    }
  };

  const _deleteLearner = async () => {
    const response = await learnerService.deleteLearner(id);
    if (response.status === 200) {
      setModal({ type: "deleted", isOpen: true });
    }
  };

  return (
    <>
      {/* Modal de éxito */}
      <Modal
        isOpen={modal.isOpen && modal.type === "success"}
        onClose={closeModal}
        type="success"
      >
        <p>Socio {id === "new" ? "añadido" : "editado"} con éxito.</p>
      </Modal>

      {/* Modal de error */}
      <Modal
        isOpen={modal.isOpen && modal.type === "error"}
        onClose={closeModal}
        type="error"
      >
        <p>El socio debe tener al menos un nombre y sección.</p>
      </Modal>

      {/* Modal de confirmación de eliminación */}
      <Modal
        isOpen={modal.isOpen && modal.type === "confirm"}
        onClose={closeModal}
        type="confirm"
        onConfirm={_deleteLearner}
        confirmText="Eliminar"
      >
        <p>¿Estás seguro de eliminar este socio? Esta acción es irreversible.</p>
      </Modal>

      {/* Modal de eliminado */}
      <Modal
        isOpen={modal.isOpen && modal.type === "deleted"}
        onClose={closeModal}
        type="success"
      >
        <p>Socio eliminado con éxito.</p>
      </Modal>

      <div className={styles.container}>
        <ScreenHeader title={`${id !== "new" ? "Editar" : "Nuevo"} socio`} />
        <form className={styles.form} onSubmit={handleSubmit}>
          <div className={styles.field}>
            <label htmlFor="nombre">Nombre:</label>
            <input
              type="text"
              id="nombre"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
          </div>

          <div className={styles.field}>
            <label htmlFor="seccion">Sección:</label>
            <select
              className={styles.select}
              id="seccion"
              value={section}
              onChange={(e) => setSection(e.target.value)}
              required
            >
              <option value="Castores">Castores</option>
              <option value="Lobatos">Lobatos</option>
              <option value="Scouts">Scouts</option>
              <option value="Escultas">Escultas</option>
              <option value="Rovers">Rovers</option>
              <option value="Scouters">Scouters</option>
            </select>
          </div>

          <div className={styles.field}>
            <label htmlFor="birthDate">Fecha nacimiento:</label>
            <input
              id="birthDate"
              value={birthDate}
              max={dayjs().format("YYYY-MM-DD")}
              type="date"
              className={styles["date-select"]}
              onChange={(e) => setbirthDate(e.target.value)}
            />
          </div>

          <button className={styles.submitButton} type="submit">Enviar</button>

          {id !== "new" && (
            <button
              type="button"
              className={styles.deleteButton}
              onClick={() => openModal("confirm")}
            >
              Eliminar
            </button>
          )}
        </form>
      </div>
    </>
  );
};

export default EditLearner;
